<template>
  <div class="container">
    <div class="icon-container">
      <i class="fas fa-lock-open fs-32"></i>
    </div>
    <h1>Acesso a usuários</h1>
    <b-form @submit.stop.prevent style="width: 100%">
      <label for="password">Senha de acesso</label>
      <InputPassword
        :disabled="!token"
        :value.sync="password"
        :state="token ? passwordValidation : null"
        placeholder=""
        id="password"
        @keydown.enter.native="login"
      ></InputPassword>
      <b-form-invalid-feedback v-if="token" :state="passwordValidation">
        Digite uma senha válida. A senha é obrigatória.
      </b-form-invalid-feedback>
      <b-form-valid-feedback v-if="token" :state="passwordValidation">
        &nbsp;
      </b-form-valid-feedback>
    </b-form>
    <b-alert v-if="!token" show variant="danger" :disabled="loading">
      <b><i class="fas fa-exclamation-triangle mr-2"></i> Atenção:</b> O token
      de acesso não foi informado, verifique a URL e tente novamente.
    </b-alert>
    <b-alert v-if="isLoggedIn" show variant="warning" :disabled="loading">
      <b><i class="fas fa-exclamation-triangle mr-2"></i> Atenção:</b> Foi
      encontrado uma sessão ativa, caso prossiga, a sessão atual será encerrada.
    </b-alert>
    <div class="actions-container">
      <b-button @click="$router.push('/')" variant="outline-secondary">
        <i class="fas fa-home mr-2"></i> Voltar para a home
      </b-button>
      <b-button
        @click="login"
        variant="success"
        :disabled="!password || !token || loading"
      >
        <i class="fas fa-sign-in-alt mr-2"></i> Entrar
        <b-spinner small class="ml-2" v-if="loading"></b-spinner>
      </b-button>
    </div>

    <img src="@/assets/img/Logo Novo ConstrUp.png" width="140" class="mt-4" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import api from '@/api';
import makeToast from 'Mixins/makeToast';
import InputPassword from 'Components/Inputs/InputPassword.vue';

export default {
  name: 'Login',
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      password: '',
    };
  },
  computed: {
    passwordValidation() {
      if (!this.token) return true;

      return !!this.password.length;
    },
    token() {
      return this.$route.query.token;
    },
    isLoggedIn() {
      const jwtToken = localStorage.getItem('token');

      if (!jwtToken) return false;

      if (jwtToken === 'null') return false;
      if (jwtToken === 'undefined') return false;

      return true;
    },
  },
  mounted() {
    console.log(this.$route);
  },
  methods: {
    ...mapMutations(['setDadosUsuario', 'setToken']),
    ...mapMutations('user', ['setUserId', 'setUserType']),
    async login() {
      this.loading = true;

      try {
        const response = await api.post('/v1/admin/impersonate/login', {
          password: this.password,
          token: this.token,
        });

        const { message, info, token } = response.data;

        if (!info || !token) {
          this.makeToast(
            'Erro',
            'Não foi possível realizar o login, tente novamente.',
            'danger'
          );
          return;
        }

        localStorage.clear();

        this.setUserId(info.id || 0);
        this.setUserType(info.tipo_usuario_id || 0);

        this.setDadosUsuario(info);
        this.setToken(token);

        localStorage.setItem('dadosUsuario', JSON.stringify(info));
        localStorage.setItem('token', token);

        this.makeToast('Sucesso', message, 'success');

        this.$router.push({ name: 'lojista-meus-dados' });
      } catch (error) {
        console.log(error.response);

        const { message } = error.response.data || {};

        this.makeToast(
          'Erro',
          `Houve um erro ao realizar o login: "${message || error.message}"`,
          'danger'
        );
      } finally {
        this.loading = false;
      }
    },
  },
  components: {
    InputPassword,
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  height: 100vh;
  max-width: 350px;
  padding: 2rem 0;
}

.actions-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 80px;
  min-height: 80px;
  max-width: 80px;
  max-height: 80px;
  border-radius: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
